import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { type FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";
import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { useVolumeHover } from "~/feature/chart/providers/VolumeHoverProvider";
import { formatValue } from "~/utils/formatValue";

import * as Styled from "./VolumeIndicator.styles";

const VOLUME_TOOLTIP =
  "Total volume traded during the selected time range, for the outcomes shown on this chart.";

const iconStyles = { fontSize: "13px" };

export const VolumeIndicator: FC = () => {
  const { volumeByTimeline, isVolumeLoading } = useCoreChart();
  const { hoveredIndex } = useVolumeHover();

  if (!isVolumeLoading && !volumeByTimeline.length) {
    return null;
  }

  const isHovered = hoveredIndex !== null;
  const lastIndex = isHovered ? hoveredIndex : volumeByTimeline.length - 1;
  const cumulativeVolume = volumeByTimeline
    .slice(0, lastIndex + 1)
    .reduce<number>((sum, value) => sum + (value ?? 0), 0);

  return (
    <Styled.Root>
      <Styled.Label>Vol.</Styled.Label>
      {isVolumeLoading ? (
        <Styled.ValueSkeleton />
      ) : (
        <Styled.Value $hovered={isHovered}>
          {formatValue(cumulativeVolume)}
        </Styled.Value>
      )}
      <RichTooltip title={VOLUME_TOOLTIP}>
        <InfoOutlinedIcon color="disabled" sx={iconStyles} />
      </RichTooltip>
    </Styled.Root>
  );
};
